import React from "react";
import useSupportStore from "../../stores/chatStore";
import { convertUTCDateToLocalDateString } from "../../helpers/dateHelper";

const SupportTicketFileInfo: React.FC = () => {
  const { fileInfo } = useSupportStore();

  // Функция для рендеринга скелетона
  const renderSkeleton = () => (
    <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
  );

  return (
    <>
      <div className="mt-4 p-5 border rounded-xl border-tableline grid grid-cols-[20%_80%] gap-x-4 gap-y-3">
        {/* Series */}
        <p className="md:text-sm max-xl:text-lg text-textsecondary">Series</p>
        {fileInfo?.series ? (
          <p className="md:text-sm max-xl:text-lg text-right overflow-hidden whitespace-normal pr-4">
            {fileInfo.series}
          </p>
        ) : (
          renderSkeleton()
        )}

        {/* ECU */}
        <p className="md:text-sm max-xl:text-lg text-textsecondary">ECU</p>
        {fileInfo?.ecu ? (
          <p className="md:text-sm max-xl:text-lg text-right overflow-hidden whitespace-normal pr-4">
            {fileInfo.ecu}
          </p>
        ) : (
          renderSkeleton()
        )}

        {/* Engine */}
        <p className="md:text-sm max-xl:text-lg text-textsecondary">Engine</p>
        {fileInfo?.engine ? (
          <p className="md:text-sm max-xl:text-lg text-right overflow-hidden whitespace-normal pr-4">
            {fileInfo.engine}
          </p>
        ) : (
          renderSkeleton()
        )}

        {/* Software */}
        <p className="md:text-sm max-xl:text-lg text-textsecondary">Software</p>
        {fileInfo?.software ? (
          <p className="md:text-sm max-xl:text-lg text-right overflow-hidden whitespace-normal pr-4">
            {fileInfo.software}
          </p>
        ) : (
          renderSkeleton()
        )}

        {/* Uploaded */}
        <p className="md:text-sm max-xl:text-lg text-textsecondary">Uploaded</p>
        {fileInfo?.uploaded ? (
          <p className="md:text-sm max-xl:text-lg text-right pr-4">
            {convertUTCDateToLocalDateString(fileInfo.uploaded)}
          </p>
        ) : (
          renderSkeleton()
        )}
      </div>
    </>
  );
};

export default SupportTicketFileInfo;